'use client';
import { ReactNode } from 'react';
import { Dialog, DialogProps } from '@mui/material';

export function BaseDialog({ children, ...otherProps }: BaseDialogProps) {
  return <Dialog {...otherProps}>{children}</Dialog>;
}

interface BaseDialogProps extends Omit<DialogProps, 'children'> {
  children: ReactNode;
}
